__turbopack_context__.v({
  "center": "alignment-module-scss-module__dM37KG__center",
  "left": "alignment-module-scss-module__dM37KG__left",
  "right": "alignment-module-scss-module__dM37KG__right",
});
